<mat-checkbox
  formControlName="value"
  (click)="next()"
  [disabled]="disabled"
  [checked]="value === true"
  [indeterminate]="value === false"
>
  <ng-content></ng-content>
</mat-checkbox>
